import * as React from "react";
export default () => <div />;

export const processQuery = graphql`
  fragment ProcessItem on PrismicProcessEdge {
    node {
      id
      type
      data {
        name
        description {
          html
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/fragments/process.js